import axios from "axios";

const fetch = (search = "", page = 1, per = 10) =>
  axios.get(
    `/api/v1/meta_iq_data?search=${search}&page=${page}&per_page=${per}`
  );

const create = payload =>
  axios.post("/api/v1/meta_iq_data", { meta_iq_data: payload });

const destroy = ids => {
  const params = new URLSearchParams(ids.map(id => ["ids[]", id]));
  return axios.delete(`/api/v1/meta_iq_data/1?${params.toString()}`);
};

const createRequest = (categories, databaseDetails) =>
  axios.post(
    `https://testmetaiq.azurewebsites.net/api/database?categories=[${categories}]`,
    databaseDetails
  );

const fetchStatus = auditId =>
  axios.post(`https://testmetaiq.azurewebsites.net/api/status`, {
    audit_id: auditId,
  });

const fetchData = (currentPage, pageSize, auditId) =>
  axios.post(`https://testmetaiq.azurewebsites.net/api/data`, {
    audit_id: auditId,
    page: currentPage,
    rows: pageSize,
  });

const metaIQApi = {
  fetch,
  create,
  destroy,
  createRequest,
  fetchStatus,
  fetchData,
};

export default metaIQApi;
